import React from "react";
import PropTypes from "prop-types";
import { useNavigate, useLocation } from "react-router-dom";
import Collapse from "@material-ui/core/Collapse";
import { useTheme } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { ListItemText, List, ListItem, Typography } from "@material-ui/core";

import Icon from "@/components/Icon";
import useStyles from "./style";

const Item = ({ item, openParentLabel, setOpenParentLabel }) => {
  const location = useLocation();
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const renderItem = (item, isSub, depth = 0) => {
    const isActive =
      item.link === "/"
        ? location.pathname === "/"
        : location.pathname === item.link;

    const handleClick = () => {
      if (item.subItems && item.subItems.length > 0) {
        const firstSub = item.subItems.find(
          (sub) => sub.sidebarShow && sub.component
        );
        if (firstSub) navigate(firstSub.link, { replace: true });
        setOpenParentLabel(item.sidebarLabel);
      } else {
        navigate(item.link, { replace: true });
      }
    };

    const renderSubItems = (subItems) => {
      const isParentOfSelected = () => {
        if (!openParentLabel) return false;

        const isDescendant = (parent, targetLabel) => {
          if (!parent.subItems) return false;

          return parent.subItems.some((child) => {
            if (child.sidebarLabel === targetLabel) return true;
            return isDescendant(child, targetLabel);
          });
        };

        return isDescendant(item, openParentLabel);
      };

      const isParentDePremierNiveau =
        !!item.subItems && item.subItems.length > 0 && depth === 0;

      const isOpen =
        openParentLabel === item.sidebarLabel ||
        isParentOfSelected() ||
        isParentDePremierNiveau;

      return (
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {subItems.subItems
              ? renderSubItems(subItems.subItems)
              : subItems
                  .filter(
                    (e) =>
                      e.sidebarShow !== false && e.sidebarLabel && e.sideBarIcon
                  )
                  .map((subItem, index) => (
                    <div key={index}>
                      {renderItem(subItem, true, depth + 1)}
                    </div>
                  ))}
          </List>
        </Collapse>
      );
    };

    return (
      <>
        <ListItem
          button
          onClick={handleClick}
          className={!isSub ? classes.item : classes.subItem}
          style={{ paddingLeft: theme.spacing(2 + depth * 2) }}
        >
          <Icon
            className={item.sideBarIcon}
            color={isActive ? "primary" : "secondary"}
            classes={{ root: classes.icon }}
          />
          <ListItemText
            disableTypography
            primary={
              <Typography
                variant="body1"
                classes={{ root: classes.text }}
                style={{
                  color: isActive
                    ? theme.palette.orange.main
                    : theme.palette.blue.main,
                }}
              >
                {t(item.sidebarLabel)}
              </Typography>
            }
          />
        </ListItem>
        {item.subItems && renderSubItems(item.subItems, item.sidebarLabel)}
      </>
    );
  };

  return renderItem(item);
};

Item.propTypes = {
  item: PropTypes.shape(),
};

export default Item;
